import { AfterViewInit, Component, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { LoginService } from '../../../core/services/Login/login.service';
import { Router } from '@angular/router';
import { CustomErrorStateMatcher } from '../../../core/models/CustomErrorStateMatcher';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { ResponseVm } from '../../../core/models/response-vm';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../../shared/components/dialogbox/dialog/dialog.component';
import { LoginHeaderComponent } from '../../../shared/components/login-header/login-header.component';
import { FooterComponent } from '../../../shared/components/app-footer/footer.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [
    CommonModule,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatFormField,
    MatError,
    MatInputModule,
    MatButtonModule,
    LoginHeaderComponent, 
    FooterComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ReSetPasswordComponent implements OnInit {
  private router = inject(Router);
  loginService = inject(LoginService);
  localStorage = inject(AesEncDecService);
  matcher = new CustomErrorStateMatcher();
  dialog = inject(MatDialog);
  loginFailedMessage: string;
  resetForm: FormGroup;
  formValues: any;
  error_messages = {
    'password': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'Password must be at least 10 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 30 characters long.' }
    ],
    'reEnterPassword': [
      { type: 'required', message: 'confirm password is required.' },
      { type: 'minlength', message: 'Password must be at least 10 characters long.' },
      { type: 'maxlength', message: 'Confirm password cannot be more than 30 characters long.' },

      { type: 'passwordNotMatch', message: 'Passwords do not match.' }
    ],
  }
  constructor(private fb: FormBuilder) {

    this.resetForm = this.fb.group({
      userID: new FormControl({ value: '', disabled: true }, Validators.required),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30)
      ])),
      reEnterPassword: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30)
      ])),
    }, {
      validators: this.passwordMatchValidator
    });

  }

  ngOnInit(): void {
    const userID = JSON.parse(this.localStorage?.getData("loginUserId")?.toString() || '{}');
    this.resetForm.get('userID')?.setValue(userID);
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const reEnterPassword = formGroup.get('reEnterPassword')?.value;
    return password === reEnterPassword ? null : { passwordNotMatch: true };
  }
  receiveFormValues(values: any): void {
    this.formValues = values;
  }

  onSubmit() {
    this.resetForm.get('userID')?.enable();
    this.formValues = this.resetForm.value;
    // Disable the userId field again
    this.resetForm.get('userID')?.disable();

    this.loginService.changePassword(this.formValues).subscribe({
      next: (response: ResponseVm) => {
        this.dialog.open(DialogComponent, {
          minWidth: '300px',
          data: {
            message: response.responseMessage,
          },
        });
        this.router.navigateByUrl('login');

      },
      error: error => {
        this.loginFailedMessage = error.error.ResponseMessage;
        console.error('There was an error!', error);
      }
    });
  }

}